import { useMemo } from "react";
import { useWatch } from "react-hook-form";

import { useGetServiceDetailsConfig } from "api/queries/location/useGetServiceDetailsConfig";

export function useIncotermsHeaderSummary() {
  const location = useWatch({ name: "organizational.location" });
  const incotermsValue = useWatch({ name: "service.incoterms" }) as string | undefined;

  const { data: serviceDetailsConfig } = useGetServiceDetailsConfig(location ?? "", {
    enabled: !!location,
  });

  return useMemo(() => {
    const effectiveValue = incotermsValue ?? serviceDetailsConfig?.service_options?.incoterm_default;

    const incotermsLabel =
      serviceDetailsConfig?.service_options?.incoterm_values?.find((opt) => opt.value === effectiveValue)?.label ?? "";

    return { incotermsLabel };
  }, [incotermsValue, serviceDetailsConfig]);
}
